export function getAttributes() {
  const attributesElements = document.querySelectorAll<HTMLInputElement>(
    '[name^="attributes"]',
  );
  const attributes: Record<string, string> = {};
  for (const attributesElement of Array.from(attributesElements)) {
    const key = (attributesElement as any).name.match(/\[(.*)\]/)[1];
    attributes[key] = attributesElement.value;
  }
  return attributes;
}
